import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
const initialState = {
    isAuthenticated: false,
    isApplicationLoading: false,
    info: {},
    companyAvailability: false,
    companyAvailabilityMessage: '',
    redirectPath: null,
    registrationError: null,
};
const reducer = createReducer(initialState, (builder) => builder
    .addCase(actions.register, (state) => {
    state.registrationError = null; // Clear any previous errors when attempt starts
})
    .addCase(actions.register.success, (state) => {
    state.registrationError = null;
})
    .addCase(actions.register.fail, (state, { payload }) => {
    state.registrationError = payload ? payload : 'Registration failed';
})
    .addCase(actions.checkToken, (state) => {
    state.isAuthenticated = undefined;
    state.isApplicationLoading = true;
})
    .addCase(actions.checkToken.fail, (state) => {
    state.isApplicationLoading = false;
    state.isAuthenticated = false;
})
    .addCase(actions.checkToken.success, (state) => {
    state.isAuthenticated = true;
    state.isApplicationLoading = false;
})
    .addCase(actions.checkCompany, (state) => {
    state.companyAvailability = null;
    state.companyAvailabilityMessage = null;
})
    .addCase(actions.checkCompany.success, (state, { payload }) => {
    state.companyAvailability = true;
    state.companyAvailabilityMessage = payload;
})
    .addCase(actions.checkCompany.fail, (state, { payload }) => {
    state.companyAvailability = false;
    state.companyAvailabilityMessage = payload;
})
    .addCase(actions.updateUser, (state, { payload }) => {
    state.info = payload;
    state.isAuthenticated = true;
})
    .addCase(actions.setRedirectPath, (state, { payload }) => {
    state.redirectPath = payload;
})
    .addCase(actions.resetUserState, () => initialState));
export default reducer;
